import { render, staticRenderFns } from "./ContactVcf.vue?vue&type=template&id=8c5111f4&scoped=true"
import script from "./ContactVcf.vue?vue&type=script&lang=js"
export * from "./ContactVcf.vue?vue&type=script&lang=js"
import style0 from "./ContactVcf.vue?vue&type=style&index=0&id=8c5111f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5111f4",
  null
  
)

export default component.exports